import { render, staticRenderFns } from "./pos_scheduler.vue?vue&type=template&id=45353990&scoped=true&"
import script from "./pos_scheduler.vue?vue&type=script&lang=js&"
export * from "./pos_scheduler.vue?vue&type=script&lang=js&"
import style0 from "./pos_scheduler.vue?vue&type=style&index=0&id=45353990&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45353990",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45353990')) {
      api.createRecord('45353990', component.options)
    } else {
      api.reload('45353990', component.options)
    }
    module.hot.accept("./pos_scheduler.vue?vue&type=template&id=45353990&scoped=true&", function () {
      api.rerender('45353990', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/pos/pos_settings/tabs/pos_scheduler.vue"
export default component.exports